export default __webpack_public_path__ + "static/media/edwin_oracle.a9fff728.png";